// extracted by mini-css-extract-plugin
export default {"left":"src-pages-SalesChannelContentEditor-SalesChannelEditorShoppingCartPage-css__left--7csSy"};